import { css } from '@emotion/react';

import { ApiPropertyProject } from '@kaiizen/kai-pro-api';

import { PageLayout } from '../Layout';
import { useContractorProjects } from '../State';
import { LAYOUT2, TYPOGRAPHY2 } from '../Styles';
import { GenericLoadingPage } from './GenericPages';

const LIST_STYLE = css`
  display: flex;
  flex-direction: column;
  gap: ${LAYOUT2.spacing1}px;
  padding: ${LAYOUT2.spacing2}px;
`;

const CARD_STYLE = css`
  display: flex;
  flex-direction: column;
  gap: ${LAYOUT2.spacingHalf}px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: ${LAYOUT2.spacingHalf}px;
  padding: ${LAYOUT2.spacing1p5}px;
`;

const PROJECT_NAME_STYLE = css`
  ${TYPOGRAPHY2.mediumBold};
  color: var(--text);
`;

const PROJECT_META_STYLE = css`
  ${TYPOGRAPHY2.small};
  color: var(--text2);
`;

const EMPTY_STYLE = css`
  ${TYPOGRAPHY2.small};
  color: var(--text2);
  padding: ${LAYOUT2.spacing2}px;
  text-align: center;
`;

const ContractorProjectCard = ({ project }: { project: ApiPropertyProject }) => (
  // Display-only for the spike — opening a project is intentionally out of scope (Stage 4 stops here).
  <div css={CARD_STYLE}>
    <span css={PROJECT_NAME_STYLE}>{project.name}</span>
    {project.orgProperty?.address && <span css={PROJECT_META_STYLE}>{project.orgProperty.address}</span>}
    <span css={PROJECT_META_STYLE}>Status: {project.status}</span>
  </div>
);

/**
 * Contractor-facing dashboard listing the projects the authenticated contractor is
 * assigned to (via the contractor-to-project link). Spike: lists projects only —
 * opening a project / viewing scopes is out of scope.
 */
export const ContractorDashboardPage = () => {
  const { contractorProjects, isLoading } = useContractorProjects();

  if (isLoading && !contractorProjects) return <GenericLoadingPage title='My Projects' loadingMessage='Loading your projects...' />;

  return (
    <PageLayout title='My Projects' contentLayoutStyling='none'>
      <div css={LIST_STYLE}>
        {contractorProjects && contractorProjects.length > 0
          ? contractorProjects.map(project => <ContractorProjectCard key={project.id} project={project} />)
          : <div css={EMPTY_STYLE}>You haven't been assigned to any projects yet.</div>}
      </div>
    </PageLayout>
  );
};
